export default __webpack_public_path__ + "static/media/040_tunnel.first.19ee3936.png";